import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { BillingChargeCreateDrawer } from '../../../../../../features/billing/charge/billing-charge-create-drawer';
import { BillingChargesTable } from '../../../../../../features/billing/charge/billing-charges-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/billing/charge/_charge/')({
  head: () => getPageHead('Billing Charges'),
  component: BillingChargesList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <RequiresAccess write>
        <BillingChargeCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Billing Charge" size="small" />} />
      </RequiresAccess>

      {filter}
    </HorizontalStack>
  );
}

function BillingChargesList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <BillingChargesTable context={viewContext} HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
